import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocVisibility = async ({ docId, visibility }) => {
  return await request.put(
    `/Docs/visibility/${docId}?visibility=${visibility}`,
    null,
    'При изменении видимости документа произошла ошибка',
    'Error'
  );
};

const useChangeDocVisibility = () => {
  const mutation = useMutation(changeDocVisibility, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocVisibility: mutation.isLoading,
    changeDocVisibility: mutation.mutateAsync,
  };
};

export default useChangeDocVisibility;
